/**
 * Base API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FormatConfigEntry { 
    type?: FormatConfigEntry.TypeEnum;
    element?: FormatConfigEntry.ElementEnum;
    path?: string;
    componentId?: string;
    pathAndComponentIdPresent?: boolean;
    pathPresent?: boolean;
    componentIdPresent?: boolean;
}
export namespace FormatConfigEntry {
    export type TypeEnum = 'BELEG' | 'BENUTZER' | 'BODENBEDECKUNG' | 'ZUSATZANGABEN' | 'CAPITITEL' | 'EIGENTUMANTEIL' | 'HANDELSANGABEN' | 'GEBAEUDE' | 'GEBAEUDEEINGANGSADRESSE' | 'GRUNDBUCHAMT' | 'GRUNDBUCHGESCHAEFT' | 'GEOMETERGESCHAEFT' | 'GRUNDBUCHPERSON' | 'GRUNDPFANDRECHT' | 'AMTLICHE_BEWERTUNG' | 'GRUNDPFANDRECHTBELASTUNG' | 'GRUNDSTUECK' | 'GRUNDSTUECKBESCHREIBUNG' | 'PERSONENADRESSE' | 'RECHTEID' | 'STAMMPERSON' | 'PERSONGB' | 'STANDARDRECHT' | 'TIMEPOINT' | 'AVMUTATION' | 'AMTNUMMER' | 'RECHTLISTITEM';
    export const TypeEnum = {
        BELEG: 'BELEG' as TypeEnum,
        BENUTZER: 'BENUTZER' as TypeEnum,
        BODENBEDECKUNG: 'BODENBEDECKUNG' as TypeEnum,
        ZUSATZANGABEN: 'ZUSATZANGABEN' as TypeEnum,
        CAPITITEL: 'CAPITITEL' as TypeEnum,
        EIGENTUMANTEIL: 'EIGENTUMANTEIL' as TypeEnum,
        HANDELSANGABEN: 'HANDELSANGABEN' as TypeEnum,
        GEBAEUDE: 'GEBAEUDE' as TypeEnum,
        GEBAEUDEEINGANGSADRESSE: 'GEBAEUDEEINGANGSADRESSE' as TypeEnum,
        GRUNDBUCHAMT: 'GRUNDBUCHAMT' as TypeEnum,
        GRUNDBUCHGESCHAEFT: 'GRUNDBUCHGESCHAEFT' as TypeEnum,
        GEOMETERGESCHAEFT: 'GEOMETERGESCHAEFT' as TypeEnum,
        GRUNDBUCHPERSON: 'GRUNDBUCHPERSON' as TypeEnum,
        GRUNDPFANDRECHT: 'GRUNDPFANDRECHT' as TypeEnum,
        AMTLICHE_BEWERTUNG: 'AMTLICHE_BEWERTUNG' as TypeEnum,
        GRUNDPFANDRECHTBELASTUNG: 'GRUNDPFANDRECHTBELASTUNG' as TypeEnum,
        GRUNDSTUECK: 'GRUNDSTUECK' as TypeEnum,
        GRUNDSTUECKBESCHREIBUNG: 'GRUNDSTUECKBESCHREIBUNG' as TypeEnum,
        PERSONENADRESSE: 'PERSONENADRESSE' as TypeEnum,
        RECHTEID: 'RECHTEID' as TypeEnum,
        STAMMPERSON: 'STAMMPERSON' as TypeEnum,
        PERSONGB: 'PERSONGB' as TypeEnum,
        STANDARDRECHT: 'STANDARDRECHT' as TypeEnum,
        TIMEPOINT: 'TIMEPOINT' as TypeEnum,
        AVMUTATION: 'AVMUTATION' as TypeEnum,
        AMTNUMMER: 'AMTNUMMER' as TypeEnum,
        RECHTLISTITEM: 'RECHTLISTITEM' as TypeEnum
    };
    export type ElementEnum = 'AMTNUMMER_MIT' | 'AMTNUMMER_OHNE' | 'BELEG_TYP00' | 'BELEG_TYP01' | 'BELEG_TYP02' | 'BELEG_TYP03' | 'BENUTZER_TYP00' | 'BENUTZER_TYP01' | 'BODENBEDECKUNG_TYP00' | 'ZUSATZANGABEN_TYP00' | 'CAPITITEL_TYP00' | 'EIGENTUMANTEIL_TYP00' | 'EIGENTUMANTEIL_TYP01' | 'HANDELSANGABEN_TYP00' | 'GEBAEUDE_TYP00' | 'GEBAEUDE_TYP01' | 'GEBAEUDE_TYP02' | 'GEBAEUDE_TYP03' | 'GEBAEUDE_TYP04' | 'GEBAEUDE_TYP05' | 'GEBAEUDE_TYP06' | 'GEBAEUDEEINGANGSADRESSE_TYP00' | 'GRUNDBUCHAMT_TYP00' | 'GRUNDBUCHAMT_TYP01' | 'GRUNDBUCHGESCHAEFT_TYP00' | 'GRUNDBUCHGESCHAEFT_TYP01' | 'GRUNDBUCHGESCHAEFT_TYP02' | 'GEOMETERGESCHAEFT_TYP00' | 'GRUNDBUCHPERSON_TYP00' | 'GRUNDBUCHPERSON_TYP01' | 'GRUNDPFANDRECHT_TYP00' | 'GRUNDPFANDRECHT_TYP01' | 'GRUNDPFANDRECHT_TYP02' | 'AMTLICHE_BEWERTUNG_TYP00' | 'AMTLICHE_BEWERTUNG_TYP01' | 'AMTLICHE_BEWERTUNG_TYP02' | 'AMTLICHE_BEWERTUNG_TYP03' | 'GRUNDPFANDRECHTBELASTUNG_TYP00' | 'GRUNDPFANDRECHTBELASTUNG_TYP01' | 'GRUNDSTUECK_TYP00' | 'GRUNDSTUECK_TYP01' | 'GRUNDSTUECK_TYP02' | 'GRUNDSTUECK_BESCHREIBUNG_TYP00' | 'PERSONENADRESSE_TYP00' | 'PERSONENADRESSE_TYP01' | 'PERSONGB_TYP00' | 'PERSONGB_TYP01' | 'RECHTEID_TYP00' | 'RECHTLISTITEM_DEFAULT' | 'RECHTLISTITEM_RECHTE_ID' | 'STAMMPERSON_TYP00' | 'STAMMPERSON_TYP01' | 'STAMMPERSON_TYP02' | 'STANDARDRECHT_TYP00' | 'STANDARDRECHT_TYP01' | 'STANDARDRECHT_TYP02' | 'STANDARDRECHT_TYP03' | 'AVMUTATION_TYP00' | 'TIMEPOINT_TYP00' | 'TIMEPOINT_TYP01';
    export const ElementEnum = {
        AMTNUMMER_MIT: 'AMTNUMMER_MIT' as ElementEnum,
        AMTNUMMER_OHNE: 'AMTNUMMER_OHNE' as ElementEnum,
        BELEG_TYP00: 'BELEG_TYP00' as ElementEnum,
        BELEG_TYP01: 'BELEG_TYP01' as ElementEnum,
        BELEG_TYP02: 'BELEG_TYP02' as ElementEnum,
        BELEG_TYP03: 'BELEG_TYP03' as ElementEnum,
        BENUTZER_TYP00: 'BENUTZER_TYP00' as ElementEnum,
        BENUTZER_TYP01: 'BENUTZER_TYP01' as ElementEnum,
        BODENBEDECKUNG_TYP00: 'BODENBEDECKUNG_TYP00' as ElementEnum,
        ZUSATZANGABEN_TYP00: 'ZUSATZANGABEN_TYP00' as ElementEnum,
        CAPITITEL_TYP00: 'CAPITITEL_TYP00' as ElementEnum,
        EIGENTUMANTEIL_TYP00: 'EIGENTUMANTEIL_TYP00' as ElementEnum,
        EIGENTUMANTEIL_TYP01: 'EIGENTUMANTEIL_TYP01' as ElementEnum,
        HANDELSANGABEN_TYP00: 'HANDELSANGABEN_TYP00' as ElementEnum,
        GEBAEUDE_TYP00: 'GEBAEUDE_TYP00' as ElementEnum,
        GEBAEUDE_TYP01: 'GEBAEUDE_TYP01' as ElementEnum,
        GEBAEUDE_TYP02: 'GEBAEUDE_TYP02' as ElementEnum,
        GEBAEUDE_TYP03: 'GEBAEUDE_TYP03' as ElementEnum,
        GEBAEUDE_TYP04: 'GEBAEUDE_TYP04' as ElementEnum,
        GEBAEUDE_TYP05: 'GEBAEUDE_TYP05' as ElementEnum,
        GEBAEUDE_TYP06: 'GEBAEUDE_TYP06' as ElementEnum,
        GEBAEUDEEINGANGSADRESSE_TYP00: 'GEBAEUDEEINGANGSADRESSE_TYP00' as ElementEnum,
        GRUNDBUCHAMT_TYP00: 'GRUNDBUCHAMT_TYP00' as ElementEnum,
        GRUNDBUCHAMT_TYP01: 'GRUNDBUCHAMT_TYP01' as ElementEnum,
        GRUNDBUCHGESCHAEFT_TYP00: 'GRUNDBUCHGESCHAEFT_TYP00' as ElementEnum,
        GRUNDBUCHGESCHAEFT_TYP01: 'GRUNDBUCHGESCHAEFT_TYP01' as ElementEnum,
        GRUNDBUCHGESCHAEFT_TYP02: 'GRUNDBUCHGESCHAEFT_TYP02' as ElementEnum,
        GEOMETERGESCHAEFT_TYP00: 'GEOMETERGESCHAEFT_TYP00' as ElementEnum,
        GRUNDBUCHPERSON_TYP00: 'GRUNDBUCHPERSON_TYP00' as ElementEnum,
        GRUNDBUCHPERSON_TYP01: 'GRUNDBUCHPERSON_TYP01' as ElementEnum,
        GRUNDPFANDRECHT_TYP00: 'GRUNDPFANDRECHT_TYP00' as ElementEnum,
        GRUNDPFANDRECHT_TYP01: 'GRUNDPFANDRECHT_TYP01' as ElementEnum,
        GRUNDPFANDRECHT_TYP02: 'GRUNDPFANDRECHT_TYP02' as ElementEnum,
        AMTLICHE_BEWERTUNG_TYP00: 'AMTLICHE_BEWERTUNG_TYP00' as ElementEnum,
        AMTLICHE_BEWERTUNG_TYP01: 'AMTLICHE_BEWERTUNG_TYP01' as ElementEnum,
        AMTLICHE_BEWERTUNG_TYP02: 'AMTLICHE_BEWERTUNG_TYP02' as ElementEnum,
        AMTLICHE_BEWERTUNG_TYP03: 'AMTLICHE_BEWERTUNG_TYP03' as ElementEnum,
        GRUNDPFANDRECHTBELASTUNG_TYP00: 'GRUNDPFANDRECHTBELASTUNG_TYP00' as ElementEnum,
        GRUNDPFANDRECHTBELASTUNG_TYP01: 'GRUNDPFANDRECHTBELASTUNG_TYP01' as ElementEnum,
        GRUNDSTUECK_TYP00: 'GRUNDSTUECK_TYP00' as ElementEnum,
        GRUNDSTUECK_TYP01: 'GRUNDSTUECK_TYP01' as ElementEnum,
        GRUNDSTUECK_TYP02: 'GRUNDSTUECK_TYP02' as ElementEnum,
        GRUNDSTUECK_BESCHREIBUNG_TYP00: 'GRUNDSTUECK_BESCHREIBUNG_TYP00' as ElementEnum,
        PERSONENADRESSE_TYP00: 'PERSONENADRESSE_TYP00' as ElementEnum,
        PERSONENADRESSE_TYP01: 'PERSONENADRESSE_TYP01' as ElementEnum,
        PERSONGB_TYP00: 'PERSONGB_TYP00' as ElementEnum,
        PERSONGB_TYP01: 'PERSONGB_TYP01' as ElementEnum,
        RECHTEID_TYP00: 'RECHTEID_TYP00' as ElementEnum,
        RECHTLISTITEM_DEFAULT: 'RECHTLISTITEM_DEFAULT' as ElementEnum,
        RECHTLISTITEM_RECHTE_ID: 'RECHTLISTITEM_RECHTE_ID' as ElementEnum,
        STAMMPERSON_TYP00: 'STAMMPERSON_TYP00' as ElementEnum,
        STAMMPERSON_TYP01: 'STAMMPERSON_TYP01' as ElementEnum,
        STAMMPERSON_TYP02: 'STAMMPERSON_TYP02' as ElementEnum,
        STANDARDRECHT_TYP00: 'STANDARDRECHT_TYP00' as ElementEnum,
        STANDARDRECHT_TYP01: 'STANDARDRECHT_TYP01' as ElementEnum,
        STANDARDRECHT_TYP02: 'STANDARDRECHT_TYP02' as ElementEnum,
        STANDARDRECHT_TYP03: 'STANDARDRECHT_TYP03' as ElementEnum,
        AVMUTATION_TYP00: 'AVMUTATION_TYP00' as ElementEnum,
        TIMEPOINT_TYP00: 'TIMEPOINT_TYP00' as ElementEnum,
        TIMEPOINT_TYP01: 'TIMEPOINT_TYP01' as ElementEnum
    };
}


